import React, {useEffect, useState } from 'react';
import axios from 'axios';
import '../css/NuevaGuia.css';
import Menu from './components/Menu';
import PasoGuia from './components/PasoGuia';
import { ListaUnidadesMedida, ObtenerNombreMedida} from '../shared/UnidadesMedida';
import { ListaDepartamentos, ListaProvincias, ListaDistritos, ObtenerUbicacion} from '../shared/Ubigeo';
import { Link, useNavigate, useBeforeUnload} from 'react-router-dom';
import { NMTipoGuiaRemision, NMMotivoTraslado, NMTipoDocumento, NMTipoComprobante } from '../shared/Denominaciones';
import FormularioActor from './components/FormularioActor';
import FormularioProductos from './components/FormularioProductos';
import FormularioTransportista from './components/FormularioTransportista';
import ListaBienes from './components/ListaBienes';
import { ValidarSesion } from '../shared/Validaciones';
import { dB64 } from '../shared/Encriptacion';
import FormularioConductor from './components/FormularioConductor';
import FormularioVehiculo from './components/FormularioVehiculo';
import Confirmacion from './components/Confirmación';
import FormularioDirecciones from './components/FormularioDirecciones';
import FormularioAsignarConductor from './components/FormularioAsignarConductor';
import FormularioAsignarVehiculo from './components/FormularioAsignarVehiculo';

export default function NuevaGuiaTransportista(){

    //================================================================================================================
    //#region HOOKS ESTADO 
    //================================================================================================================
    
    //Estados guia remisión
    const[serieDoc, setSerieDoc] = useState("");
    const[numeroDoc, setNumeroDoc] = useState("");
    const[fechaEmision, setFechaEmision] = useState("");
    const[docEmisor, setDocEmisor] = useState("");
    const[nombreEmisor, setNombreEmisor] = useState("");
    const[tipoDocEmisor, setTipoDocEmisor] = useState("6");
    const[tipoGuia, setTipoGuia] = useState("09");
    const[tipoDocProveedor, setTipoDocProveedor] = useState("");
    const[nroDocProveedor, setNroDocProveedor] = useState("");
    const[razSocProveedor, setRazSocProveedor] = useState("");
    const[tipoDocCliente, setTipoDocCliente] = useState("");
    const[nroDocCliente, setNroDocCliente] = useState("");
    const[razSocCliente, setRazSocCliente] = useState("");
    const[tipoDocRelacionado, setTipoDocRelacionado] = useState("01");
    const[nroDocRelacionado, setNroDocRelacionado] = useState("");
    const[emisorDocRelacionado, setEmisorDocRelacionado] = useState("");
    const[listaProductos, setListaProductos] = useState([]);
    const[unidadCarga, setUnidadCarga] = useState("KGM");
    const[pesoBrutoCarga, setPesoBrutoCarga] = useState("");
    const[cantBultos, setCantBultos] = useState(0);
    const[ubigeoPartida, setUbigeoPartida] = useState("010101");
    const[direccionPartida, setDireccionPartida] = useState("");
    const[ubigeoLlegada, setUbigeoLlegada] = useState("010101");
    const[direccionLlegada, setDireccionLlegada] = useState("");
    const[fechaEnvio, setFechaEnvio] = useState("");
    // transporte privado
    const[tipoDocConductor, setTipoDocConductor] = useState("1");
    const[docConductor, setDocConductor] = useState("");
    const[nombreConductor, setNombreConductor] = useState("");
    const[apellidoConductor, setApellidoConductor] = useState("");
    const[licenciaConductor, setLicenciaConductor] = useState("");

    const[tipoDocConductorS1, setTipoDocConductorS1] = useState("1");
    const[docConductorS1, setDocConductorS1] = useState("");
    const[nombreConductorS1, setNombreConductorS1] = useState("");
    const[apellidoConductorS1, setApellidoConductorS1] = useState("");
    const[licenciaConductorS1, setLicenciaConductorS1] = useState("");

    const[tipoDocConductorS2, setTipoDocConductorS2] = useState("1");
    const[docConductorS2, setDocConductorS2] = useState("");
    const[nombreConductorS2, setNombreConductorS2] = useState("");
    const[apellidoConductorS2, setApellidoConductorS2] = useState("");
    const[licenciaConductorS2, setLicenciaConductorS2] = useState("");

    const[placaVehiculo, setPlacaVehiculo] = useState("");
    const[entidadVehiculo, setEntidadVehiculo] = useState("");
    const[codigoEntidadVehiculo, setCodigoEntidadVehiculo] = useState("");
    const[autorizacionVehiculo, setAutorizacionVehiculo] = useState("");
    const[descripcionVehiculo, setDescripcionVehiculo] = useState("");

    const[placaVehiculoS1, setPlacaVehiculoS1] = useState("");
    const[entidadVehiculoS1, setEntidadVehiculoS1] = useState("");
    const[codigoEntidadVehiculoS1, setCodigoEntidadVehiculoS1] = useState("");
    const[autorizacionVehiculoS1, setAutorizacionVehiculoS1] = useState("");
    const[descripcionVehiculoS1, setDescripcionVehiculoS1] = useState("");

    const[placaVehiculoS2, setPlacaVehiculoS2] = useState("");
    const[entidadVehiculoS2, setEntidadVehiculoS2] = useState("");
    const[codigoEntidadVehiculoS2, setCodigoEntidadVehiculoS2] = useState("");
    const[autorizacionVehiculoS2, setAutorizacionVehiculoS2] = useState("");
    const[descripcionVehiculoS2, setDescripcionVehiculoS2] = useState("");
    //observaciones
    const[observaciones, setObservaciones] = useState("");

    //ESTADOS DE INFORMACIÓN ADICIONAL DE LOS ACTORES
    const[direccionCliente, setDireccionCliente] = useState("");
    const[direccionProveedor, setDireccionProveedor] = useState("");
    const[direccionEmisor, setDireccionEmisor] = useState("");
    const[ubigeoCliente, setUbigeoCliente] = useState("");
    const[ubigeoProveedor, setUbigeoProveedor] = useState("");
    const[ubigeoEmisor, setUbigeoEmisor] = useState("");
    const[usarDireccionPartida, setUsarDireccionPartida] = useState(false);
    const[usarDireccionLlegada, setUsarDireccionLlegada] = useState(false);

    //ESTADOS DE ASIGNACION DE CONDUCTORES Y VEHÍCULOS
    const[conductorAsignar, setConductorAsignar] = useState("p");
    const[vehiculoAsignar, setVehiculoAsignar] = useState("p");

    //ESTADOS DE CONTENIDO
    const[selectTipoGuia, setSelectTipoGuia] = useState("");
    const[selectSerie, setSelectSerie] = useState("");
    const[selectDocumentos, setSelectDocumentos] = useState(<></>);
    const[modalAgregar, setModalAgregar] = useState(""); //utilizado para todos los formularios de registro manual
    const[selectTipoCpe, setSelectTipoCpe] = useState(<></>);

    //ESTADOS DE FLUJO DE PASOS
    const[bloquear2, setBloquear2] = useState(true);
    const[bloquear3, setBloquear3] = useState(true);
    const[bloquear4, setBloquear4] = useState(true);
    const[bloquear5, setBloquear5] = useState(true);
    const[bloquear6, setBloquear6] = useState(true);

    //Estados de búsqueda
    const[busquedaProveedor, setBusquedaProveedor] = useState("");
    const[resultBusquedaProveedor, setResultBusquedaProveedor] = useState("");
    const[busquedaCliente, setBusquedaCliente] = useState("");
    const[resultBusquedaCliente, setResultBusquedaCliente] = useState("");
    const[busquedaProducto, setBusquedaProducto] = useState("");
    const[resultBusquedaProducto, setResultBusquedaProducto] = useState("");
    const[busquedaConductor, setBusquedaConductor] = useState("");
    const[resultBusquedaConductor, setResultBusquedaConductor] = useState("");
    const[busquedaVehiculo, setBusquedaVehiculo] = useState("");
    const[resultBusquedaVehiculo, setResultBusquedaVehiculo] = useState("");

    //Estados de lista de productos
    const[descProdAgregar, setDescProdAgregar] = useState("");
    const[codProdAgregar, setCodProdAgregar] = useState("");
    const[undProdAgregar, setUndProdAgregar] = useState("NIU");
    const[cantProdAgregar, setCantProdAgregar] = useState("1");

    //Estados de puntos de partida y llegada
    const[dptoPartida, setDptoPartida] = useState("01");
    const[provPartida, setProvPartida] = useState("01");
    const[distPartida, setDistPartida] = useState("01");
    const[dptoLlegada, setDptoLlegada] = useState("01");
    const[provLlegada, setProvLlegada] = useState("01");
    const[distLlegada, setDistLlegada] = useState("01");

    //Estados de indicador de proceso en ejecución
    const[indicadorGenerandoGuia, setIndicadorGenerandoGuia] = useState(false);

    //#endregion

    //================================================================================================================
    //#region HOOKS EFFECT
    //================================================================================================================

    useEffect(()=>{
        ValidarSesion();
        ObtenerDatosEmpresa();
        ObtenerTiposGuia();
        ObtenerTiposCpe();
        ObtenerTiposDocumento();
        DefinirFechaEnvio();
        DefinirFechaEmision();

        cargarDatosProv("6", docEmisor, razSocProveedor, direccionEmisor, ubigeoEmisor);
        const handleBeforeUnload = (event) => {
            // El mensaje puede no aparecer en todos los navegadores, pero el navegador mostrará su propia alerta de confirmación.
            const message = '¿Estás seguro de que deseas abandonar la página?';
            event.preventDefault(); // Algunos navegadores requieren esto para la alerta.
            event.returnValue = message; // Específicamente para los navegadores como Chrome.
            return message; // Para algunos navegadores que necesitan esta línea.
          };
      
          // Registrar el evento antes de que el usuario salga o recargue la página.
          window.addEventListener('beforeunload', handleBeforeUnload);
      
          // Limpieza cuando el componente se desmonta.
          return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
          };
    },[]);

    // Cargar series al cambiar el tipo de Guía
    useEffect(() => {
        ObtenerSeries();
    },[tipoGuia])

    // Validación para el paso 2
    useEffect(()=>{
        validarPaso2();
    },[docEmisor, nombreEmisor, tipoGuia, serieDoc]);

    // Validación para el paso 3
    useEffect(()=>{
        validarPaso3();
    },[tipoDocCliente, nroDocCliente, razSocCliente, tipoDocProveedor, nroDocProveedor, razSocProveedor, bloquear2]);

    // Validación para el paso 4
    useEffect(()=>{
        validarPaso4();
    }, [listaProductos, unidadCarga, pesoBrutoCarga, bloquear3, emisorDocRelacionado, nroDocRelacionado]);

    // Validación para el paso 5
    useEffect(()=>{
        validarPaso5();
    },[ubigeoPartida, ubigeoLlegada, direccionPartida, direccionLlegada, bloquear4]);

    // Validación para el paso 6
    useEffect(()=>{
        validarPaso6();
    },[tipoDocConductor, docConductor, nombreConductor, apellidoConductor, licenciaConductor, 
        placaVehiculo, bloquear5]);

    // Realizar consulta de proveedores cuando la longitud del campo es mayor o igual a 2 caracteres
    useEffect(()=>{
        if(busquedaProveedor.length >= 2){
            ConsultaProveedor();
        }else{
            if(busquedaProveedor.length == 0){
                HandlerResultBusquedaProveedor("");
            }
        }
    },[busquedaProveedor]);

    // Realizar consulta de clientes cuando la longitud del campo es mayor o igual a 2 caracteres
    useEffect(()=>{
        if(busquedaCliente.length >= 2){
            ConsultaCliente();
        }else{
            if(busquedaCliente.length == 0){
                HandlerResultBusquedaCliente("");
            }
        }
    },[busquedaCliente]);

    // Realizar consulta de productos cuando la longitud del campo es mayor o igual a 2 caracteres
    useEffect(() => {
        if(busquedaProducto.length >= 2){
            ConsultaProducto();
        }else{
            if(busquedaProducto.length == 0){
                HandlerResultBusquedaProducto("");
            }
        }
    }, [busquedaProducto]);

    //Realizar consulta de conductores cuando la longitud del campo es mayor o igual a 2 caracteres
    useEffect(()=>{
        if(busquedaConductor.length >= 2){
            ConsultaConductor();
        }else{
            if(busquedaConductor.length == 0){
                HandlerResultBusquedaConductor("");
            }
        }
    },[busquedaConductor])

    // Realizar consulta de vehiculos cuando la longitud del campo es mayor o igual a 2 caracteres
    useEffect(()=>{
        if(busquedaVehiculo.length >= 2){
            ConsultaVehiculo();
        }else{
            if(busquedaVehiculo.length == 0){
                HandlerResultBusquedaVehiculo("");
            }
        }
    },[busquedaVehiculo])

    // Actualizar ubigeo y reestableces inferiores al cambiar departamento, provincia o distrito de partida
    useEffect(()=>{
        HandlerDistPartida("01");
        HandlerProvPartida("01");
        HandlerUbigeoPartida(`${dptoPartida}${provPartida}${distPartida}`);
    },[dptoPartida]);
    useEffect(()=>{
        HandlerDistPartida("01");
        HandlerUbigeoPartida(`${dptoPartida}${provPartida}${distPartida}`);
    },[provPartida]);
    useEffect(()=>{
        HandlerUbigeoPartida(`${dptoPartida}${provPartida}${distPartida}`);
    },[distPartida]);

    // Actualizar ubigeo y reestableces inferiores al cambiar departamento, provincia o distrito de llegada
    useEffect(()=>{
        HandlerDistLlegada("01");
        HandlerProvLlegada("01");
        HandlerUbigeoLlegada(`${dptoLlegada}${provLlegada}${distLlegada}`);
    },[dptoLlegada]);
    useEffect(()=>{
        HandlerDistLlegada("01");
        HandlerUbigeoLlegada(`${dptoLlegada}${provLlegada}${distLlegada}`);
    },[provLlegada]);
    useEffect(()=>{
        HandlerUbigeoLlegada(`${dptoLlegada}${provLlegada}${distLlegada}`);
    },[distLlegada]);

    // Actualizar emisor de documento relacionado junto con el proveedor
    useEffect(()=>{
        HandlerEmisorDocRelacionado(nroDocProveedor);
    }, [nroDocProveedor]);

    //#endregion

    //================================================================================================================
    //#region HOOK NAVIGATE
    //================================================================================================================
    const navigate = useNavigate();
    
    //#endregion

     //================================================================================================================
    //#region HOOK BEFOREUNLOAD
    //================================================================================================================
    // useBeforeUnload((e) => {
    //     e.preventDefault();
    //     console.log("modificación de página");
    // })
    
    //#endregion

    //================================================================================================================
    //#region HANDLERS 
    //================================================================================================================
    
    //Estados guia remisión
    
    const HandlerSerieDoc = (serie) => {
        const partes = serie.split('-');
        setSerieDoc(partes[0]);
        HandlerNumeroDoc(partes[1]);
    }
    const HandlerNumeroDoc = (valor) => {
        let correlativo = Number.parseInt(valor);
        correlativo += 1;
        correlativo = correlativo.toString().padStart(7,"0");

        setNumeroDoc(correlativo);
    }
    const HandlerFechaEmision = (valor) => {
        const fechaActual = new Date();
        const fechaLimiteInferior = new Date();
        fechaLimiteInferior.setDate(fechaActual.getDate() - 2);

        const fechaValor = new Date(valor);

        if (fechaValor >= fechaLimiteInferior && fechaValor <= fechaActual) {
            const nuevaFecha = valor.replace('T',' ');
            setFechaEmision(nuevaFecha);
        } else {
            DefinirFechaEmision();
        }
    }
    const HandlerDocEmisor = (nroDocumento) => setDocEmisor(nroDocumento);
    const HandlerNombreEmisor = (nombre) => setNombreEmisor(nombre);
    const HandlerTipoGuia = (codigo) => setTipoGuia(codigo);
    const HandlerTipoDocProveedor = (codigo) => setTipoDocProveedor(codigo);
    const HandlerNroDocProveedor = (valor) => setNroDocProveedor(valor);
    const HandlerRazSocProveedor = (valor) => setRazSocProveedor(valor);
    const HandlerTipoDocCliente = (codigo) => setTipoDocCliente(codigo);
    const HandlerNroDocCliente = (valor) => setNroDocCliente(valor);
    const HandlerRazSocCliente = (valor) => setRazSocCliente(valor);
    const HandlerTipoDocRelacionado = (codigo) => setTipoDocRelacionado(codigo);
    const HandlerNroDocRelacionado = (valor) => {
        if(valor.length == 4 && nroDocRelacionado.includes('-') == false){
            setNroDocRelacionado(`${valor.toUpperCase()}-`);
        }else{
            setNroDocRelacionado(valor.toUpperCase());
        }
    }
    const HandlerEmisorDocRelacionado = (valor) => setEmisorDocRelacionado(valor);
    const HandlerListaProductos = (lista) => setListaProductos(lista);
    const HandlerUnidadCarga = (codigo) => setUnidadCarga(codigo);
    const HandlerPesoBrutoCarga = (peso) => setPesoBrutoCarga(peso);
    const HandlerCantBultos = (cantidad) => setCantBultos(cantidad);
    const HandlerUbigeoPartida = (ubigeo) => setUbigeoPartida(ubigeo);
    const HandlerDireccionPartida = (direccion) => setDireccionPartida(direccion);
    const HandlerUbigeoLlegada = (ubigeo) => setUbigeoLlegada(ubigeo);
    const HandlerDireccionLlegada = (direccion) => setDireccionLlegada(direccion);
    const HandlerFechaEnvio = (fecha) => setFechaEnvio(fecha);
    // transporte privado
    const HandlerTipoDocConductor = (codigo) => setTipoDocConductor(codigo);
    const HandlerDocConductor = (valor) => setDocConductor(valor);
    const HandlerNombreConductor = (nombre) => setNombreConductor(nombre.toUpperCase());
    const HandlerApellidoConductor = (apellido) => setApellidoConductor(apellido.toUpperCase());
    const HandlerLicenciaConductor = (valor) => {
        let formato = valor.toUpperCase().trim();
        setLicenciaConductor(formato);
    }

    const HandlerTipoDocConductorS1 = (codigo) => setTipoDocConductorS1(codigo);
    const HandlerDocConductorS1 = (valor) => setDocConductorS1(valor);
    const HandlerNombreConductorS1 = (nombre) => setNombreConductorS1(nombre.toUpperCase());
    const HandlerApellidoConductorS1 = (apellido) => setApellidoConductorS1(apellido.toUpperCase());
    const HandlerLicenciaConductorS1 = (valor) => {
        let formato = valor.toUpperCase().trim();
        setLicenciaConductorS1(formato);
    }

    const HandlerTipoDocConductorS2 = (codigo) => setTipoDocConductorS2(codigo);
    const HandlerDocConductorS2 = (valor) => setDocConductorS2(valor);
    const HandlerNombreConductorS2 = (nombre) => setNombreConductorS2(nombre.toUpperCase());
    const HandlerApellidoConductorS2 = (apellido) => setApellidoConductorS2(apellido.toUpperCase());
    const HandlerLicenciaConductorS2 = (valor) => {
        let formato = valor.toUpperCase().trim();
        setLicenciaConductorS2(formato);
    }

    const HandlerPlacaVehiculo = (valor) => {
        let formato = valor.replace("-","");
        formato = formato.toUpperCase().trim();
        setPlacaVehiculo(formato);
    }
    const HandlerEntidadVehiculo = (valor) => setEntidadVehiculo(valor);
    const HandlerCodigoEntidadVehiculo = (valor) => setCodigoEntidadVehiculo(valor);
    const HandlerAutorizacionVehiculo = (valor) => setAutorizacionVehiculo(valor);
    const HandlerDescripcionVehiculo = (valor) => setDescripcionVehiculo(valor);

    const HandlerPlacaVehiculoS1 = (valor) => {
        let formato = valor.replace("-","");
        formato = formato.toUpperCase().trim();
        setPlacaVehiculoS1(formato);
    }
    const HandlerEntidadVehiculoS1 = (valor) => setEntidadVehiculoS1(valor);
    const HandlerCodigoEntidadVehiculoS1 = (valor) => setCodigoEntidadVehiculoS1(valor);
    const HandlerAutorizacionVehiculoS1 = (valor) => setAutorizacionVehiculoS1(valor);
    const HandlerDescripcionVehiculoS1 = (valor) => setDescripcionVehiculoS1(valor);

    const HandlerPlacaVehiculoS2 = (valor) => {
        let formato = valor.replace("-","");
        formato = formato.toUpperCase().trim();
        setPlacaVehiculoS2(formato);
    }
    const HandlerEntidadVehiculoS2 = (valor) => setEntidadVehiculoS2(valor);
    const HandlerCodigoEntidadVehiculoS2 = (valor) => setCodigoEntidadVehiculoS2(valor);
    const HandlerAutorizacionVehiculoS2 = (valor) => setAutorizacionVehiculoS2(valor);
    const HandlerDescripcionVehiculoS2 = (valor) => setDescripcionVehiculoS2(valor);

    const HandlerObservaciones = (valor) => setObservaciones(valor);

    // Estados de Información adicional de los clientes
    const HandlerDireccionCliente = (valor) => setDireccionCliente(valor); 
    const HandlerDireccionProveedor = (valor) => setDireccionProveedor(valor);
    const HandlerDireccionEmisor = (valor) => setDireccionEmisor(valor);
    const HandlerUbigeoCliente = (valor) => setUbigeoCliente(valor);
    const HandlerUbigeoProveedor = (valor) => setUbigeoProveedor(valor);
    const HandlerUbigeoEmisor = (valor) => setUbigeoEmisor(valor);
    const HandlerUsarDireccionPartida = async () => {
        if(usarDireccionPartida){
            setUsarDireccionPartida(false);
            HandlerDireccionPartida("");
            HandlerDptoPartida('01');
        }else{
            setUsarDireccionPartida(true);
            HandlerDireccionPartida(direccionProveedor);
            if(ubigeoProveedor != ""){
                await HandlerDptoPartida(ubigeoProveedor.substring(0,2));
                await HandlerProvPartida(ubigeoProveedor.substring(2,4));
                HandlerDistPartida(ubigeoProveedor.substring(4,6));
            }
        }
    }
    const HandlerUsarDireccionLlegada = async () => {
        if(usarDireccionLlegada){
            setUsarDireccionLlegada(false);
            HandlerDireccionLlegada("");
            HandlerDptoLlegada('01');
        }else{
            setUsarDireccionLlegada(true);
            HandlerDireccionLlegada(direccionCliente);
            if(ubigeoCliente != ""){
                await HandlerDptoLlegada(ubigeoCliente.substring(0,2));
                await HandlerProvLlegada(ubigeoCliente.substring(2,4));
                HandlerDistLlegada(ubigeoCliente.substring(4,6));
            }
        }
    }

    // ESTADOS DE ASIGNACIÓN DE CONDUCTOR Y VEHÍCULOS
    const HandlerConductorAsignar = (valor) => setConductorAsignar(valor);
    const HandlerVehiculoAsignar = (valor) => setVehiculoAsignar(valor);

    // Estados de contenido
    const HandlerSelectTipoGuia = (lista) => {
        setSelectTipoGuia(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigo} >{NMTipoGuiaRemision(item.codigo)}</option>
        ))}</>)
    }
    const HandlerSelectSerie = (lista) => {
        setSelectSerie(<>{lista.map((item, index)=>(
            <option key={index} value={`${item.serie}-${item.numero}`} >{item.serie}</option>
        ))}</>)
    }
    const HandlerSelectDocumentos = (lista) => {
        setSelectDocumentos(<>{
            lista.map((item, index) => (
                <option key={index} value={item.codigo}>{item.descripcion}</option>
            ))}</>)
    }
    const HandlerSelectTipoCpe = (lista) => {
        setSelectTipoCpe(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigo}>{item.nombre}</option>
        ))}</>)
    }

    // Estados de flujo de pasos
    const HandlerBloquear2 = (valor) => {
        if(valor == false){
            setBloquear2(false);
        }else{
            setBloquear2(true);
        }
    }
    const HandlerBloquear3 = (valor) => {
        if(valor == false){
            setBloquear3(false);
        }else{
            setBloquear3(true);
        }
    }
    const HandlerBloquear4 = (valor) => {
        if(valor == false){
            setBloquear4(false);
        }else{
            setBloquear4(true);
        }
    }
    const HandlerBloquear5 = (valor) => {
        if(valor == false){
            setBloquear5(false);
        }else{
            setBloquear5(true);
        }
    }
    const HandlerBloquear6 = (valor) => {
        if(valor == false){
            setBloquear6(false);
        }else{
            setBloquear6(true);
        }
    }

    // Estados de búsqueda
    const HandlerBusquedaProveedor = (valor) => setBusquedaProveedor(valor);
    const HandlerResultBusquedaProveedor = (lista) => {
        if(lista.length > 0){
            setResultBusquedaProveedor(lista.map( (item, index) => (
                <button onClick={() => cargarDatosProv(item.tipoDoc, item.nroDoc, item.razSoc, item.direccion, item.ubigeo)} key={index} type='button' className='list-group-item list-group-item-action'>{`${item.razSoc} - ${item.nroDoc}`}</button>
            )));
        }else{
            setResultBusquedaProveedor("");
        }
    }
    const HandlerBusquedaCliente = (valor) => setBusquedaCliente(valor);
    const HandlerResultBusquedaCliente = (lista) => {
        if(lista.length > 0){
            setResultBusquedaCliente(lista.map( (item, index) => (
                <button onClick={() => cargarDatosCli(item.tipoDoc, item.nroDoc, item.razSoc, item.direccion, item.ubigeo)} key={index} type='button' className='list-group-item list-group-item-action'>{`${item.razSoc} - ${item.nroDoc}`}</button>
            )));
        }else{
            setResultBusquedaCliente("");
        }
    }
    const HandlerBusquedaProducto = (valor) => setBusquedaProducto(valor);
    const HandlerResultBusquedaProducto = (lista) => {
        if(lista.length > 0){
            setResultBusquedaProducto(lista.map( (item, index) => (
                <button key={index} onClick={() => cargarDatosProd(item.descripcion, item.codigo, item.unidad)} type='button' className='list-group-item list-group-item-action'>{`${item.descripcion} - ${item.codigo}`}</button>
            )));
        }else{
            setResultBusquedaProducto("");
        }
    }
    const HandlerBusquedaConductor = (valor) => setBusquedaConductor(valor);
    const HandlerResultBusquedaConductor = (lista) => {
        if(lista.length > 0){
            setResultBusquedaConductor(lista.map( (item, index) => (
                <button key={index} onClick={() => {
                    switch (conductorAsignar) {
                        case 'p':
                            cargarDatosCond(item.nombre, item.tipoDoc, item.nroDoc, item.nroLicencia)
                            break;
                        case 's1':
                            cargarDatosCondS1(item.nombre, item.tipoDoc, item.nroDoc, item.nroLicencia)
                            break;
                        case 's2':
                            cargarDatosCondS2(item.nombre, item.tipoDoc, item.nroDoc, item.nroLicencia)
                            break;
                    }
                }} type='button' className='list-group-item list-group-item-action'>{`${item.nombre}`}</button>
            )));
        }else{
            setResultBusquedaConductor("");
        }
    }
    const HandlerBusquedaVehiculo = (valor) => setBusquedaVehiculo(valor.toUpperCase());
    const HandlerResultBusquedaVehiculo = (lista) => {
        if(lista.length > 0){
            setResultBusquedaVehiculo(lista.map( (item, index) => (
                <button key={index} onClick={() => {
                    switch (vehiculoAsignar) {
                        case 'p':
                            cargarDatosVehiculo(item.placa, item.entidad, item.codigoEntidad, item.autorizacion, item.descripcion)
                            break;
                        case 's1':
                            cargarDatosVehiculoS1(item.placa, item.entidad, item.codigoEntidad, item.autorizacion, item.descripcion)
                            break;
                        case 's2':
                            cargarDatosVehiculoS2(item.placa, item.entidad, item.codigoEntidad, item.autorizacion, item.descripcion)
                            break;
                    }
                }} type='button' className='list-group-item list-group-item-action'>{`${item.placa} - ${item.descripcion}`}</button>
            )));
        }else{
            setResultBusquedaVehiculo("");
        }
    }

    // Estados de lista de productos
    const HandlerDescProdAgregar = (descripcion) => setDescProdAgregar(descripcion);
    const HandlerCodProdAgregar = (codigo) => setCodProdAgregar(codigo);
    const HandlerUndProdAgregar = (codigo) => setUndProdAgregar(codigo);
    const HandlerCantProdAgregar = (cantidad) => setCantProdAgregar(cantidad);

    // Estados de puntos de partida y llegada
    const HandlerDptoPartida = (codigo) => setDptoPartida(codigo);
    const HandlerProvPartida = (codigo) => setProvPartida(codigo);
    const HandlerDistPartida = (codigo) => setDistPartida(codigo);
    const HandlerDptoLlegada = (codigo) => setDptoLlegada(codigo);
    const HandlerProvLlegada = (codigo) => setProvLlegada(codigo);
    const HandlerDistLlegada = (codigo) => setDistLlegada(codigo);

    //Indicador de proceso en ejecución
    const HandlerIndicadorGenerandoGuia = (valor) => setIndicadorGenerandoGuia(valor);
    //#endregion

    //================================================================================================================
    //#region FUNCIONES 
    //================================================================================================================
    
    // FUNCIONES ASÍNCRONAS
    // Obtener datos del emisor de la guía de remisión
    async function ObtenerDatosEmpresa(){
        try {
            let response = await axios.get(URL_DATOS_EMPRESA, {
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }

            HandlerDocEmisor(response.data.ruc);
            HandlerNombreEmisor(response.data.razonSocial);
            HandlerDireccionEmisor(response.data.direccion);
            HandlerUbigeoEmisor(response.data.ubigeo);

            HandlerNroDocProveedor(response.data.ruc);
            HandlerRazSocProveedor(response.data.razonSocial);
            HandlerDireccionProveedor(response.data.direccion);
            HandlerUbigeoProveedor(response.data.ubigeo);
        } catch (error) {
            console.log(error.message);
        }
    }
    async function ObtenerTiposGuia(){
        try {
            let response = await axios.get(URL_TIPOS_GUIA, {
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }

            HandlerSelectTipoGuia(response.data.tipos);
            let itemTransportista = response.data.tipos[Number.parseInt(response.data.tipos.length) - 1].codigo;
            HandlerTipoGuia(itemTransportista);
        } catch (error) {
            console.log(error.message);
        }
    }
    async function ObtenerTiposDocumento(){
        try{
            const response = await axios.get(URL_CONSULTA_TIPOS_DOCUMENTO, {
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            HandlerSelectDocumentos(response.data.lista);

        }catch(error){
            console.log(error.message);
        }
    }
    async function ObtenerSeries(){
        try{
            let response = await axios.get(URL_SERIES,{
                params:{
                    tipoGuia: "31"
                },
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });
            
            const datos = response.data.series;
            HandlerSelectSerie(datos);
            HandlerSerieDoc(`${datos[0].serie}-${datos[0].numero}`);

            const selectSeries = document.getElementById("serie");
            selectSeries.selectedIndex = 0;
        }catch(error) {
            console.log(error.message);
        }
    }
    async function ObtenerTiposCpe(){
        try{
            const response = await axios.get(URL_TIPOS_COMPROBANTE,{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerSelectTipoCpe(response.data.lista);
        }catch(error){
            console.log(error);
        }
    }
    // Buscar proveedores registrados en la base de datos
    async function ConsultaProveedor(){
        try{
            axios.get(URL_CONSULTA_PROVEEDOR,{
                params:{
                    tipoBusqueda: 'p',
                    busqueda: busquedaProveedor
                },
                headers:HEADERS_API
            }).then(response=>{
                return response.data;
            }).then(response=>{
                if(response.lista){
                    // console.log(response.lista);
                    HandlerResultBusquedaProveedor(response.lista);
                }
            });
        }catch(error){
            console.log(error.message);
        } 
    }
    // Buscar clientes registrados en la base de datos
    async function ConsultaCliente(){
        try{
            axios.get(URL_CONSULTA_PROVEEDOR,{
                params:{
                    tipoBusqueda: 'c',
                    busqueda: busquedaCliente
                }, 
                headers:HEADERS_API
            }).then(response=>{
                return response.data;
            }).then(response=>{
                if(response.lista){
                    // console.log(response.lista);
                    HandlerResultBusquedaCliente(response.lista);
                }
            });
        }catch(error){
            console.log(error.message);
        } 
    }
    // Buscar productos registrados en la base de datos
    async function ConsultaProducto(){
        try{
            axios.get(URL_CONSULTA_PRODUCTO,{
                params:{
                    busqueda: busquedaProducto
                },
                headers: HEADERS_API
            }).then(response=>{
                return response.data;
            }).then(response=>{
                if(response.lista){
                    // console.log(response.lista);
                    HandlerResultBusquedaProducto(response.lista);
                }
            });
        }catch(error){
            console.log(error.message);
        }
    }
    //Buscar conductores registrados en la base de datos
    async function ConsultaConductor(){
        try{
            let response = await axios.get(URL_CONSULTA_CONDUCTOR, {
                params:{
                    busqueda: busquedaConductor
                },
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerResultBusquedaConductor(response.data.lista);
        }catch(error){
            console.log(error.message);
        }
    }
    // Buscar vehículos registrados en la base de datos
    async function ConsultaVehiculo(){
        try {
            let response = await axios.get(URL_CONSULTA_VEHICULO, {
                params:{
                    busqueda: busquedaVehiculo
                },
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            })

            HandlerResultBusquedaVehiculo(response.data.lista);
        } catch (error) {
            console.log(error.message);
        }
    }

    //Funciones de flujo de pasos
    const validarPaso2 = () => {
        if(docEmisor == "" || nombreEmisor == "" || tipoGuia == "" || serieDoc == ""){
            HandlerBloquear2(true);
        }else{
            HandlerBloquear2(false);
        }
    }
    const validarPaso3 = () => {
        try{

            if( tipoDocCliente == "" || nroDocCliente == "" || razSocCliente == "" || tipoDocProveedor == "" ||
                nroDocProveedor == "" || razSocProveedor == "" || bloquear2 == true){
                    throw new Error();
            }

            HandlerBloquear3(false);
        }catch(error){
            HandlerBloquear3(true);
        }
    }
    const validarPaso4 = () => {
        try{

            if(bloquear3 == true || listaProductos.length == 0 || unidadCarga == "" || pesoBrutoCarga <= 0){
                throw new Error();
            }

            // if(emisorDocRelacionado != "" && nroDocRelacionado == ""){
            //     throw new Error();
            // }

            // if(nroDocRelacionado != "" && emisorDocRelacionado == ""){
            //     throw new Error();
            // }

            // if(emisorDocRelacionado != "" && emisorDocRelacionado.length != 11){
            //     console.log(nroDocRelacionado.length);
            //     throw new Error();
            // }

            HandlerBloquear4(false);
        }catch(error){
            HandlerBloquear4(true);
        }
    }
    const validarPaso5 = () => {
        if(bloquear4 == false && ubigeoPartida != "" && ubigeoLlegada != "" && direccionPartida != "" && direccionLlegada != ""){
            HandlerBloquear5(false);
        }else{
            HandlerBloquear5(true);
        }
    }
    const validarPaso6 = () => {
        let validacionDatos = false;
        if(tipoDocConductor == "" || docConductor == "" || nombreConductor == "" || apellidoConductor == "" 
            || licenciaConductor == "" || placaVehiculo == ""){
            validacionDatos = false;    
        }else{
            validacionDatos = true;
        }

        if(validacionDatos && bloquear5 == false){
            HandlerBloquear6(false);
        }
    }

    //Funciones complementarias
    const cargarDatosProv = (tipoDoc, nroDoc, razSoc, direccion, ubigeo) => {
        HandlerTipoDocProveedor(tipoDoc);
        HandlerNroDocProveedor(nroDoc);
        HandlerRazSocProveedor(razSoc);
        HandlerDireccionProveedor(direccion);
        HandlerUbigeoProveedor(ubigeo);
        HandlerBusquedaProveedor("");
    }
    const cargarDatosCli = (tipoDoc, nroDoc, razSoc, direccion, ubigeo) => {
        HandlerTipoDocCliente(tipoDoc);
        HandlerNroDocCliente(nroDoc);
        HandlerRazSocCliente(razSoc);
        HandlerDireccionCliente(direccion);
        HandlerUbigeoCliente(ubigeo);
        HandlerBusquedaCliente("");
    }
    const cargarDatosProd = (descripcion, codigo, unidad) => {
        HandlerDescProdAgregar(descripcion);
        HandlerCodProdAgregar(codigo);
        HandlerUndProdAgregar(unidad);
        HandlerBusquedaProducto("");
        resaltarProductoAgregado();
    }
    const cargarDatosCond = (nombre, tipoDoc, nroDoc, nroLicencia) => {
        HandlerNombreConductor(nombre);
        HandlerApellidoConductor(nombre);
        HandlerTipoDocConductor(tipoDoc);
        HandlerDocConductor(nroDoc);
        HandlerLicenciaConductor(nroLicencia);
        HandlerBusquedaConductor("");
    }
    const cargarDatosCondS1 = (nombre, tipoDoc, nroDoc, nroLicencia) => {
        HandlerNombreConductorS1(nombre);
        HandlerApellidoConductorS1(nombre);
        HandlerTipoDocConductorS1(tipoDoc);
        HandlerDocConductorS1(nroDoc);
        HandlerLicenciaConductorS1(nroLicencia);
        HandlerBusquedaConductor("");
    }
    const cargarDatosCondS2 = (nombre, tipoDoc, nroDoc, nroLicencia) => {
        HandlerNombreConductorS2(nombre);
        HandlerApellidoConductorS2(nombre);
        HandlerTipoDocConductorS2(tipoDoc);
        HandlerDocConductorS2(nroDoc);
        HandlerLicenciaConductorS2(nroLicencia);
        HandlerBusquedaConductor("");
    }
    const cargarDatosVehiculo = (placa, entidad, codigoEntidad, autorizacion, descripcion) => {
        HandlerPlacaVehiculo(placa);
        HandlerEntidadVehiculo(entidad);
        HandlerCodigoEntidadVehiculo(codigoEntidad);
        HandlerAutorizacionVehiculo(autorizacion);
        HandlerDescripcionVehiculo(descripcion);
        HandlerBusquedaVehiculo("");
    }
    const cargarDatosVehiculoS1 = (placa, entidad, codigoEntidad, autorizacion, descripcion) => {
        HandlerPlacaVehiculoS1(placa);
        HandlerEntidadVehiculoS1(entidad);
        HandlerCodigoEntidadVehiculoS1(codigoEntidad);
        HandlerAutorizacionVehiculoS1(autorizacion);
        HandlerDescripcionVehiculoS1(descripcion);
        HandlerBusquedaVehiculo("");
    }
    const cargarDatosVehiculoS2 = (placa, entidad, codigoEntidad, autorizacion, descripcion) => {
        HandlerPlacaVehiculoS2(placa);
        HandlerEntidadVehiculoS2(entidad);
        HandlerCodigoEntidadVehiculoS2(codigoEntidad);
        HandlerAutorizacionVehiculoS2(autorizacion);
        HandlerDescripcionVehiculoS2(descripcion);
        HandlerBusquedaVehiculo("");
    }
    const cargarDireccionPartida = (direccion, ubigeo) => {
        let departamento = ubigeo.substring(0,2);
        let provincia = ubigeo.substring(2,4);
        let distrito = ubigeo.substring(4, 6);
        
        HandlerDireccionPartida(direccion);
        HandlerDptoPartida(departamento);
        setTimeout(() => {
            HandlerProvPartida(provincia);
            setTimeout(() => {
                HandlerDistPartida(distrito);
            }, 100);
        }, 100);
    }
    const cargarDireccionLlegada = (direccion, ubigeo) => {
        let departamento = ubigeo.substring(0,2);
        let provincia = ubigeo.substring(2,4);
        let distrito = ubigeo.substring(4, 6);
        
        HandlerDireccionLlegada(direccion);
        HandlerDptoLlegada(departamento);
        setTimeout(() => {
            HandlerProvLlegada(provincia);
            setTimeout(() => {
                HandlerDistLlegada(distrito);
            }, 100);
        }, 100);
    }
    function DefinirFechaEnvio(){
        const fechaACtual = new Date();
        const anio = fechaACtual.getFullYear();
        const mes = fechaACtual.getMonth() + 1;
        const dia = fechaACtual.getDate();

        HandlerFechaEnvio(`${anio}-${mes.toString().padStart(2,'0')}-${dia.toString().padStart(2,'0')}`);
    }
    function DefinirFechaEmision(){
        const fActual = new Date();
        const anio = fActual.getFullYear();
        const mes = (fActual.getMonth() + 1).toString().padStart(2,"0");
        const dia = fActual.getDate().toString().padStart(2, "0");
        const horas = fActual.getHours().toString().padStart(2, "0");
        const minutos = fActual.getMinutes().toString().padStart(2, "0");
        const segundos = fActual.getSeconds().toString().padStart(2, "0");
        const fechaFormateada = `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
        HandlerFechaEmision(fechaFormateada);
    }
    function FechaEmisionMax(){
        const fechaActual = new Date();
        return fechaActual.toISOString().slice(0, 16);
    }
    function FechaEmisionMin(){
        const fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate() - 1);
        return fechaActual.toISOString().slice(0, 16);
    }
    function formatoFecha(fecha){
        const desglose = fecha.split("-");
        const dia = desglose[2];
        const mes = desglose[1];
        const anio = desglose[0];

        return `${dia}/${mes}/${anio}`;
    }
    function resaltarProductoAgregado(){
        let elemento = document.querySelector("#producto-cargado");
        elemento.style.background = 'rgb(253, 224, 85)';
        setTimeout(() => {
            elemento.style.background = 'transparent';
        }, 500);
    }
    const asignarConductores = (listaConductoresAsignar) => {
        let p = null;
        let s1 = null;
        let s2 = null;
        switch (listaConductoresAsignar.length) {
            case 1:
                p = listaConductoresAsignar[0];
                cargarDatosCond(p.nombre, p.tipoDoc, p.nroDoc, p.nroLicencia);
                break;
            case 2:
                p = listaConductoresAsignar[0];
                s1 = listaConductoresAsignar[1];
                cargarDatosCond(p.nombre, p.tipoDoc, p.nroDoc, p.nroLicencia);
                cargarDatosCondS1(s1.nombre, s1.tipoDoc, s1.nroDoc, s1.nroLicencia);
                break;
            case 3:
                p = listaConductoresAsignar[0];
                s1 = listaConductoresAsignar[1];
                s2 = listaConductoresAsignar[2];
                cargarDatosCond(p.nombre, p.tipoDoc, p.nroDoc, p.nroLicencia);
                cargarDatosCondS1(s1.nombre, s1.tipoDoc, s1.nroDoc, s1.nroLicencia);
                cargarDatosCondS2(s2.nombre, s2.tipoDoc, s2.nroDoc, s2.nroLicencia);
                break;
        }
    }
    const asignarVehiculos = (listaVehiculosAsignar) => {
        let p = null;
        let s1 = null;
        let s2 = null;
        switch (listaVehiculosAsignar.length) {
            case 1:
                p = listaVehiculosAsignar[0];
                cargarDatosVehiculo(p.placa, p.entidad, p.codigoEntidad, p.autorizacion, p.descripcion);
                break;
            case 2:
                p = listaVehiculosAsignar[0];
                s1 = listaVehiculosAsignar[1];
                cargarDatosVehiculo(p.placa, p.entidad, p.codigoEntidad, p.autorizacion, p.descripcion);
                cargarDatosVehiculoS1(s1.placa, s1.entidad, s1.codigoEntidad, s1.autorizacion, s1.descripcion);
                break;
            case 3:
                p = listaVehiculosAsignar[0];
                s1 = listaVehiculosAsignar[1];
                s2 = listaVehiculosAsignar[2];
                cargarDatosVehiculo(p.placa, p.entidad, p.codigoEntidad, p.autorizacion, p.descripcion);
                cargarDatosVehiculoS1(s1.placa, s1.entidad, s1.codigoEntidad, s1.autorizacion, s1.descripcion);
                cargarDatosVehiculoS2(s2.placa, s2.entidad, s2.codigoEntidad, s2.autorizacion, s2.descripcion);
                break;
        }
    }

    function quitarConductorPrincipal(){
        HandlerTipoDocConductor('1');
        HandlerDocConductor('');
        HandlerNombreConductor('');
        HandlerApellidoConductor('');
        HandlerLicenciaConductor('');
    }
    function quitarConductorS1(){
        HandlerTipoDocConductorS1('1');
        HandlerDocConductorS1('');
        HandlerNombreConductorS1('');
        HandlerApellidoConductorS1('');
        HandlerLicenciaConductorS1('');
    }
    function quitarConductorS2(){
        HandlerTipoDocConductorS2('1');
        HandlerDocConductorS2('');
        HandlerNombreConductorS2('');
        HandlerApellidoConductorS2('');
        HandlerLicenciaConductorS2('');
    }
    function quitarVehiculoPrincipal(){
        HandlerPlacaVehiculo('');
        HandlerEntidadVehiculo('');
        HandlerCodigoEntidadVehiculo('');
        HandlerAutorizacionVehiculo('');
        HandlerDescripcionVehiculo('');
    }
    function quitarVehiculoS1(){
        HandlerPlacaVehiculoS1('');
        HandlerEntidadVehiculoS1('');
        HandlerCodigoEntidadVehiculoS1('');
        HandlerAutorizacionVehiculoS1('');
        HandlerDescripcionVehiculoS1('');
    }
    function quitarVehiculoS2(){
        HandlerPlacaVehiculoS2('');
        HandlerEntidadVehiculoS2('');
        HandlerCodigoEntidadVehiculoS2('');
        HandlerAutorizacionVehiculoS2('');
        HandlerDescripcionVehiculoS2('');
    }

    //Funciones con componentes externos
    // Mostrar el formulario para realizar las consultas en SUNAT
    function cargarFormularioAgregar(funcion, esProv){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioActor funcionAgregar={funcion} funcionCancelar={cancelarFormularioAgregar} tipoActor={esProv} listaDocumentos={selectDocumentos}/>);
        formulario.classList.remove("d-none");
    }
    // Cerrar el formulario para realizar las consultas en SUNAT
    function cancelarFormularioAgregar(){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<></>);
        formulario.classList.add("d-none");
    }
    function cargarFormularioProducto(funcion){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioProductos funcionAgregar={funcion} funcionCancelar={cancelarFormularioAgregar} />);
        formulario.classList.remove("d-none");
    }
    function cargarFormularioTransportista(funcion){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioTransportista funcionAgregar={funcion} funcionCancelar={cancelarFormularioAgregar} />)
        formulario.classList.remove("d-none");
    }
    function cargarFormularioConductor(funcion){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioConductor funcionAgregar={funcion} funcionCancelar={cancelarFormularioAgregar} listaDocumentos={selectDocumentos} />);
        formulario.classList.remove("d-none");
    }
    function cargarFormularioVehiculo(){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioVehiculo funcionAgregar={cargarDatosVehiculo} funcionCancelar={cancelarFormularioAgregar} />);
        formulario.classList.remove("d-none");
    }
    function cargarFormularioAsignarConductor(){
            let formulario = document.querySelector("#formulario-agregar");
            setModalAgregar(<FormularioAsignarConductor funcionCancelar={cancelarFormularioAgregar} funcionAsignar={asignarConductores}/>);
            formulario.classList.remove("d-none");
        }
    function cargarFormularioAsignarVehiculo(){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioAsignarVehiculo funcionCancelar={cancelarFormularioAgregar} funcionAsignar={asignarVehiculos}/>);
        formulario.classList.remove("d-none");
        }
    function cargarConfirmacionRegresar(destino){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<Confirmacion funcionConfirmar={e=>navigate(`/${destino}`)} funcionCancelar={cancelarFormularioAgregar} 
        titulo={"¿Realmente desea salir del formulario?"} mensaje={"Se perderá el progreso de la guía actual"} />);
        formulario.classList.remove("d-none");
    }
    function cargarConfirmacionEmision(){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<Confirmacion funcionConfirmar={GenerarGuia} funcionCancelar={cancelarFormularioAgregar} 
        titulo={`¿Emitir GRE ${serieDoc}-${numeroDoc.toString().padStart(8,'0')}?`} 
        mensaje={`La guía de remisión será generada con la información consignada en el formulario `} />);
        formulario.classList.remove("d-none");
    }
    function cargarFormularioDirecciones(funcion){
        let formulario = document.querySelector("#formulario-agregar");
        setModalAgregar(<FormularioDirecciones funcionAgregar={funcion} funcionCancelar={cancelarFormularioAgregar} />);
        formulario.classList.remove("d-none");
    }

    //Funciones de lista de productos
    function agregarProdLista(){
        if(codProdAgregar != "" && descProdAgregar != "" && undProdAgregar != "" && cantProdAgregar > 0){
            const objeto = {
                "codigo" : codProdAgregar,
                "descripcion" : descProdAgregar,
                "unidad" : undProdAgregar,
                "cantidad" : cantProdAgregar
            }
            setListaProductos(anterior => [...anterior, objeto]);

            HandlerCodProdAgregar("");
            HandlerDescProdAgregar("");
            HandlerUndProdAgregar("NIU");
            HandlerCantProdAgregar(1);
        }else{
            alert("complete todos los datos del producto");
        }
    }
    function quitarProdLista(index){
        setListaProductos(anterior => anterior.filter((_, i) => i !== index));
    }

    //Funciones de navegación
    function manejarEventoNavegacion(){

    }

    //#endregion

    //================================================================================================================
    //#region FUNCIÓN GENERAR GUÍA
    //================================================================================================================
    const GenerarGuia = async () => {
        try{
            HandlerIndicadorGenerandoGuia(true);
            let response = await axios.post(URL_REGISTRAR_GUIA,{
                tipoComprobante: tipoGuia,
                serieDocumento: serieDoc,
                numeroDocumento: numeroDoc,
                fechaEmision: fechaEmision,
                documentoEmisor: docEmisor,
                razonSocialEmisor: nombreEmisor,
                tipoDocumentoEmisor: tipoDocEmisor,
                documentoCliente: nroDocCliente,
                razonSocialCliente: razSocCliente,
                tipoDocumentoCliente: tipoDocCliente,
                documentoProveedor: nroDocProveedor,
                razonSocialProveedor: razSocProveedor,
                tipoDocumentoProveedor: tipoDocProveedor,
                motivoTraslado: "",
                unidadPesoTotal: unidadCarga,
                pesoTotal: pesoBrutoCarga,
                cantidadBultos: Number.parseInt(cantBultos),
                inicioTraslado: fechaEnvio,
                modalidadTraslado: "",
                documentoTransportista: "",
                razonSocialTransportista: "",
                tipoDocumentoTransportista: "",
                placaVehiculo: placaVehiculo,
                autorizacionVehiculo: autorizacionVehiculo,
                documentoConductor: docConductor,
                tipoDocumentoConductor: tipoDocConductor,
                nombreConductor: nombreConductor,
                apellidoConductor: apellidoConductor,
                licenciaConductor: licenciaConductor,
                ubigeoPartida: ubigeoPartida,
                direccionPartida: direccionPartida,
                ubigeoLlegada: ubigeoLlegada,
                direccionLlegada: direccionLlegada,
                codigoEstadoSunat: "",
                descripcionEstadoSunat: "PENDIENTE",
                ticketSunat: "",
                documentoRelacionado: nroDocRelacionado,
                tipoDocumentoRelacionado: tipoDocRelacionado,
                listaProductos: listaProductos,
                registroMTCTransportista: "",
                observaciones: observaciones,
                entidadVehiculo: codigoEntidadVehiculo,
                placaVehiculoSec1: placaVehiculoS1,
                autorizacionVehiculoSec1:autorizacionVehiculoS1,
                entidadVehiculoSec1: codigoEntidadVehiculoS1,
                placaVehiculoSec2: placaVehiculoS2,
                autorizacionVehiculoSec2: autorizacionVehiculoS2,
                entidadVehiculoSec2: codigoEntidadVehiculoS2,
                tipoDocumentoConductorSec1: tipoDocConductorS1,
                documentoConductorSec1: docConductorS1,
                nombreConductorSec1: nombreConductorS1,
                apellidoConductorSec1: apellidoConductorS1,
                licenciaConductorSec1: licenciaConductorS1,
                tipoDocumentoConductorSec2: tipoDocConductorS2,
                documentoConductorSec2: docConductorS2,
                nombreConductorSec2: nombreConductorS2,
                apellidoConductorSec2: apellidoConductorS2,
                licenciaConductorSec2: licenciaConductorS2,
                detalleMotivoTraslado: ''
            },{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerIndicadorGenerandoGuia(false);
            navigate("/guias");

        }catch(error){
            if (Notification.permission === "granted") {
                new Notification(error.message);
            } else if (Notification.permission !== 'denied') {
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        new Notification(error.message);
                    }
                });
            }
            console.log(error.message);
            navigate("/guias");
        }
    }
    //#endregion

    //================================================================================================================
    //#region CONTENIDO
    //================================================================================================================
    
    return(<>
    <Menu aviso={1} funcionAviso={cargarConfirmacionRegresar} />
    <div id='formulario-agregar' className='d-none'>
        {modalAgregar}
    </div>
    <div className='container'>
        <div className='row'>
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <button className='btn btn-secondary' onClick={e=>cargarConfirmacionRegresar('guias')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                    viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                    </svg>
                    <span className='mx-2'>Regresar</span>
                </button>
            </div> 
            <div className='col-12 pb-2 fs-4 fw-semibold'>
                NUEVA GUÍA DE REMISIÓN TRANSPORTISTA
            </div>
            <small className='text-danger'>El caracter <span className='lead fw-bold'>(*)</span> indica que se debe completar el paso anterior para continuar </small>
            <div className='col-12'>
                <div className="accordion" id="pasosGuia">

                    {/* =================== Paso 1 ==================== */}
                    <PasoGuia id={'paso1'} tituloPaso={'1. Datos de emisión'} permitido={true} seleccionado={true}>
                        <div className='row'>
                            <div className='col-12 py-2'>
                                <div className='py-2'>
                                    <strong>RUC: </strong>{docEmisor == "" ? "Cargando" : docEmisor}
                                </div>
                                <div className='py-2'>
                                    <strong>Apellidos y nombres, denominación o razón social: </strong>{nombreEmisor == "" ? "Cargando" : nombreEmisor}
                                </div>
                            </div>
                            <div className='col-7 col-md-2 p-2'>
                                <div className="form-floating">
                                    <input type="datetime-local" value={fechaEmision} max={FechaEmisionMax()} min={FechaEmisionMin()} onChange={e=>HandlerFechaEmision(e.target.value)} className="form-control" id="fecha-emision" placeholder='Fecha de Emisión'/>
                                    <label htmlFor="fecha-emision">Fecha de Emisión</label>
                                </div>
                            </div>
                            <div className='col-7 col-md-2 p-2'>
                                <div className="form-floating">
                                    <select disabled value={tipoGuia} onChange={(e)=>HandlerTipoGuia(e.target.value)} className="form-select" id="tipo-guia">
                                        {selectTipoGuia}
                                    </select>
                                    <label className='d-none d-md-block' htmlFor="tipo-guia">Tipo de Guía de Remisión</label>
                                    <label className='d-md-none' htmlFor="tipo-guia">Tipo GRE</label>
                                </div>
                            </div>
                            <div className='col-5 col-md-2 p-2'>
                                <div className="form-floating">
                                    <select onChange={e => HandlerSerieDoc(e.target.value)} className="form-select" id="serie" >
                                        {selectSerie}
                                    </select>
                                    <label htmlFor="serie">Serie</label>
                                </div>
                            </div>
                        </div>    
                    </PasoGuia>

                    {/* =================== Paso 2 ==================== */}
                    <PasoGuia id={'paso2'} tituloPaso={'2. Actores (proveedor/cliente)'} bloqueado={bloquear2}>
                        <div className='row'>                            
                            <div className='col-12 col-md-6 p-2'>
                                <div className='py-1 fw-bold text-secondary'>PROVEEDOR</div>
                                <div className='py-1 d-flex justify-content-start'>
                                    <a className='btn btn-outline-primary btn-sm disabled'>Nuevo proveedor</a>
                                </div>
                                <div className='py-1 position-relative'>
                                    <small className='text-secondary'>nombre, razón social, DNI o RUC</small>
                                    <div className='form-floating'>
                                        <input disabled value={busquedaProveedor} onChange={e => HandlerBusquedaProveedor(e.target.value)} id='buscar-proveedor' type="text" className='form-control' placeholder='Buscar proveedor' autoComplete='off' />
                                        <label htmlFor="buscar-proveedor">Buscar proveedor</label>
                                        <div className='resultado-buscar'>
                                            <div className='list-group'>
                                                {resultBusquedaProveedor}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='p-2'>
                                    <strong>Tipo de Documento: </strong>
                                    {tipoDocProveedor == "" ? "" : NMTipoDocumento(tipoDocProveedor, false)}
                                </div>
                                <div className='p-2'>
                                    <strong>N° Documento: </strong>{nroDocProveedor}
                                </div>
                                <div className={razSocProveedor == "" ? "p-2" : "p-2 alert alert-primary"}>
                                    <strong>Apellidos y Nombres / Razón Social: </strong>{razSocProveedor}
                                </div>
                            </div>
                            <div className='col-12 col-md-6 p-2'>
                                <div className='py-1 fw-bold text-secondary'>CLIENTE</div>
                                <div className='py-1 d-flex justify-content-start'>
                                    <a onClick={()=>cargarFormularioAgregar(cargarDatosCli, 0)} className='btn btn-outline-primary btn-sm'>Nuevo cliente</a>
                                </div>
                                <div className='py-1 position-relative'>
                                    <small className='text-secondary'>nombre, razón social, DNI o RUC</small>
                                    <div className='form-floating'>
                                        <input value={busquedaCliente} onChange={e => HandlerBusquedaCliente(e.target.value)} id='buscar-cliente' type="text" className='form-control' placeholder='Buscar cliente' autoComplete='off' />
                                        <label htmlFor="buscar-proveedor">Buscar cliente</label>
                                        <div className='resultado-buscar'>
                                            <div className='list-group'>
                                                {resultBusquedaCliente}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='p-2'>
                                    <strong>Tipo de Documento: </strong>
                                    {tipoDocCliente == "" ? "" : NMTipoDocumento(tipoDocCliente, false)}
                                </div>
                                <div className='p-2'>
                                    <strong>N° Documento: </strong>{nroDocCliente}
                                </div>
                                <div className={razSocCliente == "" ? "p-2" : "p-2 alert alert-primary"}>
                                    <strong>Apellidos y Nombres / Razón Social: </strong>{razSocCliente}
                                </div>
                            </div>
                        </div>  
                    </PasoGuia> 

                    {/* =================== Paso 3 ==================== */}
                    <PasoGuia id={'paso3'} tituloPaso={'3. Bienes a transportar'} bloqueado={bloquear3}>
                        <div className='row'>
                            <div className='col-12 row'>
                                <div className='fw-bold col-12 py-2 fs-5'>Documento relacionado (opcional)</div>
                                <div className='col-12 col-md-6 py-1 px-3'>
                                    <div><span className='fw-bold'>EMISOR: </span> {nombreEmisor}</div>
                                    <div><span className='fw-bold'>{NMTipoDocumento(tipoDocEmisor, true)}: </span>{docEmisor}</div>
                                </div>
                                <div className='col-12 col-md-3 py-1'>
                                    <div className='form-floating'>
                                        <select onChange={e=>HandlerTipoDocRelacionado(e.target.value)} id="tipo-documento-relacionado" className='form-select'>
                                            {selectTipoCpe}
                                        </select>
                                        <label htmlFor="tipo-documento-relacionado">Comprobante</label>
                                    </div>
                                </div>
                                <div className='col-12 col-md-3 p-1'>
                                    <div className='form-floating'>
                                        <input onChange={e=>HandlerNroDocRelacionado(e.target.value)} value={nroDocRelacionado} maxLength={15} id='documento-relacionado' type="text" className='form-control text-uppercase' placeholder='Comprobante' autoComplete='off'/>
                                        <label htmlFor="documento-relacionado">Comprobante</label>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-5'>
                                <div className='fw-bold col-12 py-2 fs-5'>Buscar producto</div>
                                <div className='p-2 position-relative'>
                                    <div className='form-floating'>
                                        <input value={busquedaProducto} onChange={e => HandlerBusquedaProducto(e.target.value)} 
                                        id='codigo-producto' type="text" className='form-control' placeholder='Código' autoComplete='off'/>
                                        <label htmlFor="codigo-producto">nombre o código</label>
                                    </div>
                                    <div className='resultado-buscar'>
                                        <div className='list-group'>
                                            {resultBusquedaProducto}
                                        </div>
                                    </div>
                                </div>
                                <div className='py-1 px-2'>
                                    <a onClick={()=>cargarFormularioProducto(cargarDatosProd)} className='btn btn-outline-primary btn-sm'>Nuevo producto</a>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 row'>
                                <div id='producto-cargado' className='fw-bold col-12 py-2 text-center'>{`${descProdAgregar} - ${codProdAgregar}`}</div>
                                <div className='col-12 col-md-6 p-2'>
                                    <div className='form-floating'>
                                        <select disabled value={undProdAgregar} onChange={e => HandlerUndProdAgregar(e.target.value)} 
                                        id="unidad-producto" className='form-select' placeholder='Unidad de medida'>
                                            <ListaUnidadesMedida/>
                                        </select>
                                        <label htmlFor="unidad-producto">Unidad de medida</label>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 p-2'>
                                    <div className='form-floating'>
                                        <input value={cantProdAgregar} onChange={e => HandlerCantProdAgregar(e.target.value)} 
                                        id='cantidad-producto' type="number" className='form-control' placeholder='Cantidad' min={1} />
                                        <label htmlFor="cantidad-producto">Cantidad</label>
                                    </div>
                                </div>
                                <div className='col-12 py-1 text-white'>
                                    .
                                </div>                            
                                <div className='py-2 d-flex justify-content-center'>
                                    <button onClick={agregarProdLista} className='btn btn-primary'>Agregar</button>
                                </div>
                            </div>

                            <div className='col-12 py-3 fw-bold fs-5'>Lista de Productos</div>
                            <div className='col-12 p-2 contenedor-tabla overflow-x-scroll'>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>CÓDIGO</th>
                                            <th>DESCRIPCIÓN</th>
                                            <th>UNIDAD</th>
                                            <th>CANTIDAD</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className='table-group-divider'>
                                        <ListaBienes lista={listaProductos} funcionRetirar={quitarProdLista} />
                                    </tbody>
                                </table>
                            </div>
                            
                            <div className='col-12 py-3 fw-bold fs-5'>Datos generales de la carga</div>
                            <div className='col-12 col-md-4 p-2'>
                                <div className='form-floating'>
                                    <select value={unidadCarga} onChange={e=>HandlerUnidadCarga(e.target.value)} id="unidad-carga" 
                                    className='form-select' placeholder='Unidad de medida'>
                                        <option value="KGM">KILOGRAMO</option>
                                        <option value="TNE">TONELADAS</option>
                                    </select>
                                    <label htmlFor="unidad-carga">Unidad de medida</label>
                                </div>
                            </div>

                            <div className='col-12 col-md-4 p-2'>
                                <div className='form-floating'>
                                    <input onChange={e=>HandlerPesoBrutoCarga(e.target.value)} id='peso-bruto-carga' type="number" 
                                    className='form-control' min='0' placeholder='Peso bruto' />
                                    <label htmlFor="peso-bruto-carga">Peso bruto</label>
                                </div>
                            </div>
                            
                            {/* <div className='col-12 col-md-4 p-2'>
                                <div className='form-floating'>
                                    <input onChange={e=>HandlerCantBultos(e.target.value)} id='cant-bultos-carga' type="number" 
                                    className='form-control' min='0' placeholder='Cantidad de bultos (opcional)' />
                                    <label htmlFor="cant-bultos-carga">Cantidad de bultos (opcional)</label>
                                </div>
                            </div> */}
                        </div>
                    </PasoGuia>   

                    {/* =================== Paso 4 ==================== */}
                    <PasoGuia id={'paso4'} tituloPaso={'4. Puntos de partida y llegada'} bloqueado={bloquear4}>
                        <div className='row'>
                            <div className='pt-3 fw-bold'>Punto de partida</div>
                            <div className='py-2'>
                                <button onClick={e => cargarFormularioDirecciones(cargarDireccionPartida)} disabled={usarDireccionPartida} className='btn btn-outline-primary btn-sm'>Usar dirección frecuente</button>
                            </div>
                            <div className='py-1'>Ubigeo: {ubigeoPartida}</div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={dptoPartida} onChange={e=>HandlerDptoPartida(e.target.value)} disabled={usarDireccionPartida} id="dpto-partida" className='form-select'>
                                        <ListaDepartamentos/>
                                    </select>
                                    <label htmlFor="dpto-partida">Departamento</label>
                                </div>
                            </div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={provPartida} onChange={e=>HandlerProvPartida(e.target.value)} disabled={usarDireccionPartida} id="prov-partida" className='form-select'>
                                        <ListaProvincias departamento={dptoPartida}/>
                                    </select>
                                    <label htmlFor="prov-partida">Provincia</label>
                                </div>
                            </div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={distPartida} onChange={e=>HandlerDistPartida(e.target.value)} disabled={usarDireccionPartida} id="dist-partida" className='form-select'>
                                        <ListaDistritos departamento={dptoPartida} provincia={provPartida}/>
                                    </select>
                                    <label htmlFor="dist-partida">Distrito</label>
                                </div>
                            </div>
                            <div className='p-2 col-12'>
                                <div className='form-floating'>
                                    <input value={direccionPartida} onChange={e=>HandlerDireccionPartida(e.target.value)} disabled={usarDireccionPartida} maxLength={150} type="text" className='form-control' 
                                    placeholder='Dirección detallada' id='direccion-partida' />
                                    <label htmlFor="direccion-partida">Dirección detallada</label>
                                </div>

                                {direccionProveedor != "" && (
                                <div className='py-1'>
                                    <div className='form-check'>
                                        <input checked={usarDireccionPartida} onChange={e=>HandlerUsarDireccionPartida()} type="checkbox" className='form-check-input' id='check-direccion-partida'/>
                                        <label htmlFor="check-direccion-partida" className='form-check-label text-primary'>
                                            Usar la dirección del proveedor
                                        </label>
                                    </div>
                                </div>
                                )}
                            </div>
                            <div className='pt-3 fw-bold'>Punto de llegada</div>
                            <div className='py-2'>
                                <button onClick={e => cargarFormularioDirecciones(cargarDireccionLlegada)} disabled={usarDireccionLlegada} className='btn btn-outline-primary btn-sm'>Usar dirección frecuente</button>
                            </div>
                            <div className='py-1'>Ubigeo: {ubigeoLlegada}</div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={dptoLlegada} onChange={e=>HandlerDptoLlegada(e.target.value)} disabled={usarDireccionLlegada} id="dpto-llegada" className='form-select'>
                                        <ListaDepartamentos/>
                                    </select>
                                    <label htmlFor="dpto-llegada">Departamento</label>
                                </div>
                            </div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={provLlegada} onChange={e=>HandlerProvLlegada(e.target.value)} disabled={usarDireccionLlegada} id="prov-llegada" className='form-select'>
                                        <ListaProvincias departamento={dptoLlegada}/>
                                    </select>
                                    <label htmlFor="prov-llegada">Provincia</label>
                                </div>
                            </div>
                            <div className='p-2 col-12 col-md-4'>
                                <div className='form-floating'>
                                    <select value={distLlegada} onChange={e=>HandlerDistLlegada(e.target.value)} disabled={usarDireccionLlegada} id="dist-llegada" className='form-select'>
                                        <ListaDistritos departamento={dptoLlegada} provincia={provLlegada}/>
                                    </select>
                                    <label htmlFor="dist-llegada">Distrito</label>
                                </div>
                            </div>
                            <div className='p-2 col-12'>
                                <div className='form-floating'>
                                    <input value={direccionLlegada} onChange={e=>HandlerDireccionLlegada(e.target.value)} disabled={usarDireccionLlegada} maxLength={150} type="text" className='form-control' 
                                    placeholder='Dirección detallada' id='direccion-llegada' />
                                    <label htmlFor="direccion-llegada">Dirección detallada</label>
                                </div>
                            </div>

                            {direccionCliente != "" && (
                            <div className='py-1'>
                                <div className='form-check'>
                                    <input checked={usarDireccionLlegada} onChange={e=>HandlerUsarDireccionLlegada()} type="checkbox" className='form-check-input' id='check-direccion-llegada'/>
                                    <label htmlFor="check-direccion-llegada" className='form-check-label text-primary'>
                                        Usar la dirección del cliente
                                    </label>
                                </div>
                            </div>
                            )}
                        </div>
                    </PasoGuia>

                    {/* =================== Paso 5 ==================== */}
                    <PasoGuia id={'paso5'} tituloPaso={'5. Datos del transportista'} bloqueado={bloquear5}>
                        <div className='row'>
                            <div className='col-12 col-md-6 p-2'>
                                <div className='form-floating'>
                                    <input value={fechaEnvio} onChange={e=>{HandlerFechaEnvio(e.target.value); console.log(e.target.value)}} type="date" 
                                    className='form-control' id='fecha-envio'/>
                                    <label htmlFor="fecha-envio">Fecha de envío</label>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 p-2'>
                            {/* DIV FANTASMA PARA RELLENAR ESPACIO VACÍO */}
                            </div>
                            <div className='row'>
                                <div className='col-12 col-md-6 p-2 p-relative'>
                                    <div className='py-1 fw-bold text-secondary'>CONDUCTOR</div>
                                    {/* <div className='py-1'>
                                        <select value={conductorAsignar} onChange={e => HandlerConductorAsignar(e.target.value)} className='form-select'>
                                            <option value="p">Principal</option>
                                            <option value="s1">Secundario 1</option>
                                            <option value="s2">Secundario 2</option>
                                        </select>
                                    </div>
                                    <small className='text-secondary'>nombre o DNI</small>
                                    <div className='form-floating'>
                                        <input value={busquedaConductor} onChange={e => HandlerBusquedaConductor(e.target.value)} type="text" className='form-control' id='busqueda-conductor' placeholder='Buscar conductor' autoComplete='off'/>
                                        <label htmlFor="busqueda-conductor">Buscar conductor</label>
                                        <div className='resultado-buscar'>
                                            <div className='list-group'>
                                            {resultBusquedaConductor}
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className='py-1'>
                                        <a onClick={()=>cargarFormularioAsignarConductor()} className='btn btn-outline-primary btn-sm mx-1'>Asignar Conductores</a>
                                        <a onClick={()=>cargarFormularioConductor(cargarDatosCond)} className='btn btn-outline-primary btn-sm mx-1'>Nuevo Conductor</a>
                                    </div>
                                    <div className='p-2'>
                                        <strong>Nombre: </strong>{nombreConductor}
                                    </div>
                                    <div className='p-2'>
                                        <strong>Documento de identidad: </strong>{NMTipoDocumento(tipoDocConductor, false)}
                                    </div>
                                    <div className='p-2'>
                                        <strong>Número de documento: </strong>{docConductor}
                                    </div>
                                    <div className='p-2'>
                                        <strong>Número de licencia: </strong>{licenciaConductor}
                                    </div>
                                    {
                                        docConductor != "" && (
                                            <div className='px-2 py-1'>
                                                <button onClick={quitarConductorPrincipal} className='btn btn-sm btn-danger'>Quitar</button>
                                            </div>)
                                    }
                                    {
                                        docConductorS1 != "" && (<>
                                        <div className='p-2 text-center'>
                                        <strong>SECUNDARIO</strong>
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Nombre: </strong>{nombreConductorS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Documento de identidad: </strong>{NMTipoDocumento(tipoDocConductorS1, false)}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Número de documento: </strong>{docConductorS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Número de licencia: </strong>{licenciaConductorS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <button onClick={quitarConductorS1} className='btn btn-sm btn-danger'>Quitar</button>
                                        </div>
                                        </>)
                                    }
                                    {
                                        docConductorS2 != "" && (<>
                                        <div className='p-2 text-center'>
                                        <strong>SECUNDARIO</strong>
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Nombre: </strong>{nombreConductorS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Documento de identidad: </strong>{NMTipoDocumento(tipoDocConductorS2, false)}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Número de documento: </strong>{docConductorS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Número de licencia: </strong>{licenciaConductorS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <button onClick={quitarConductorS2} className='btn btn-sm btn-danger'>Quitar</button>
                                        </div>
                                        </>)
                                    }
                                </div>
                                <div className='col-12 col-md-6 p-2'>
                                    <div className='py-1 fw-bold text-secondary'>VEHÍCULO</div>
                                    {/* <div className='py-1'>
                                        <select value={vehiculoAsignar} onChange={e => HandlerVehiculoAsignar(e.target.value)} className='form-select'>
                                            <option value="p">Principal</option>
                                            <option value="s1">Secundario 1</option>
                                            <option value="s2">Secundario 2</option>
                                        </select>
                                    </div>
                                    <small className='text-secondary'>placa o descripción</small>
                                    <div className='form-floating'>
                                        <input value={busquedaVehiculo} onChange={e=>HandlerBusquedaVehiculo(e.target.value)} type="text" className='form-control' id='busqueda-vehiculo' placeholder='Buscar vehículo' autoComplete='off'/>
                                        <label htmlFor="busqueda-vehiculo">Buscar vehículo</label>
                                        <div className='resultado-buscar'>
                                            <div className='list-group'>
                                            {resultBusquedaVehiculo}
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className='py-1'>
                                        <a onClick={()=>cargarFormularioAsignarVehiculo()} className='btn btn-outline-primary btn-sm mx-1'>Asignar Vehiculos</a>
                                        <a onClick={cargarFormularioVehiculo} className='btn btn-outline-primary btn-sm'>Nuevo Vehículo</a>
                                    </div>
                                    <div className='p-2'>
                                        <strong>Descripción del vehículo: </strong>{descripcionVehiculo}
                                    </div>
                                    <div className='p-2'>
                                        <strong>Placa del vehículo: </strong>{placaVehiculo}
                                    </div>
                                    <div className='p-2'>
                                        <strong>N° Autorización especial: </strong>{autorizacionVehiculo}
                                    </div>
                                    <div className='p-2'>
                                        <strong>Entidad emisora: </strong>{entidadVehiculo}
                                    </div>
                                    {
                                        placaVehiculo != "" && (
                                            <div className='px-2 py-1'>
                                                <button onClick={quitarVehiculoPrincipal} className='btn btn-sm btn-danger'>Quitar</button>
                                            </div>)
                                    }
                                    {
                                        placaVehiculoS1 != "" && (<>
                                        <div className='p-2 text-center'>
                                        <strong>SECUNDARIO</strong>
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Descripción del vehículo: </strong>{descripcionVehiculoS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Placa del vehículo: </strong>{placaVehiculoS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>N° Autorización especial: </strong>{autorizacionVehiculoS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Entidad emisora: </strong>{entidadVehiculoS1}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <button onClick={quitarVehiculoS1} className='btn btn-sm btn-danger'>Quitar</button>
                                        </div>
                                        </>)
                                    }
                                    {
                                        placaVehiculoS2 != "" && (<>
                                        <div className='p-2 text-center'>
                                        <strong>SECUNDARIO</strong>
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Descripción del vehículo: </strong>{descripcionVehiculoS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Placa del vehículo: </strong>{placaVehiculoS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>N° Autorización especial: </strong>{autorizacionVehiculoS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <strong>Entidad emisora: </strong>{entidadVehiculoS2}
                                        </div>
                                        <div className='px-2 py-1'>
                                            <button onClick={quitarVehiculoS2} className='btn btn-sm btn-danger'>Quitar</button>
                                        </div>
                                        </>)
                                    }
                                </div>
                            </div>
                        </div>
                    </PasoGuia>

                    {/* =================== Paso 6 ==================== */}
                    <PasoGuia id={'paso6'} tituloPaso={'6. Vista Previa'} bloqueado={bloquear6}>
                        <div className='row'>
                            <div className='contenedor-vista-previa'>
                                <div className='vista-previa p-3 border border-dark-subtle'>
                                    <div className='row'>
                                        <div className='col-7 fw-bold fs-3 text-center my-auto'>
                                            {nombreEmisor}
                                        </div>
                                        <div className='col-5'>
                                            <div className='p-4 border border-dark'>
                                                <div className='text-center fw-bold'>
                                                    RUC N° {docEmisor}
                                                </div>
                                                <div className='text-center fw-bold py-2'>
                                                    Guía de Remisión Electrónica - {NMTipoGuiaRemision(tipoGuia)}
                                                </div>
                                                <div className='text-center fw-bold'>
                                                    {serieDoc}-{numeroDoc}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 px-3'>
                                            <div>
                                                <small>
                                                    <span className='fw-bold'>Fecha y hora de emisión: </span>
                                                    {formatoFecha(fechaEmision.split(" ")[0])} {fechaEmision.split(" ")[1]}
                                                </small>
                                            </div>
                                            <div>
                                                <small>
                                                    <span className='fw-bold'>Fecha de inicio de traslado: </span>
                                                    {formatoFecha(fechaEnvio)}
                                                </small>
                                            </div>
                                        </div>
                                        <div className='col-6 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>DATOS DEL PROVEEDOR</div>
                                            <div className='fw-bold pt-1'>{razSocProveedor}</div>
                                            <div ><span className='fw-bold'>Documento: </span>{NMTipoDocumento(tipoDocProveedor, false)}</div>
                                            <div ><span className='fw-bold'>N° Documento: </span>{nroDocProveedor}</div>
                                        </div>
                                        <div className='col-6 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>DATOS DEL DESTINATARIO</div>
                                            <div className='fw-bold pt-1'>{razSocCliente}</div>
                                            <div ><span className='fw-bold'>Documento: </span>{NMTipoDocumento(tipoDocCliente, false)}</div>
                                            <div ><span className='fw-bold'>N° Documento: </span>{nroDocCliente}</div>
                                        </div>
                                        <div className='col-6 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>PUNTO DE PARTIDA</div>
                                            <div ><span className='fw-bold'>Ubigeo: </span>{ubigeoPartida}</div>
                                            <div ><span className='fw-bold'>Dirección: </span>{direccionPartida}</div>
                                            <div className='fw-bold'><ObtenerUbicacion dpto={dptoPartida} prov={provPartida} dist={distPartida} /></div>
                                        </div>
                                        <div className='col-6 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>PUNTO DE LLEGADA</div>
                                            <div ><span className='fw-bold'>Ubigeo: </span>{ubigeoLlegada}</div>
                                            <div ><span className='fw-bold'>Dirección: </span>{direccionLlegada}</div>
                                            <div className='fw-bold'><ObtenerUbicacion dpto={dptoLlegada} prov={provLlegada} dist={distLlegada} /></div>
                                        </div>
                                        {nroDocRelacionado != "" && (
                                        <div className='col-6 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>DOCUMENTO RELACIONADO</div>
                                            <div >{NMTipoComprobante(tipoDocRelacionado)} N° {nroDocRelacionado} - RUC N° {emisorDocRelacionado}</div>
                                        </div>
                                        )}
                                        <div className='col-12 p-3'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>BIENES A TRANSPORTAR</div>
                                            <div className='overflow-x-scroll'>
                                                <table className="table table-striped table-light">
                                                    <thead>
                                                        <tr>
                                                            <th>CÓDIGO</th>
                                                            <th>DESCRIPCIÓN</th>
                                                            <th>UNIDAD</th>
                                                            <th>CANTIDAD</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='table-group-divider'>
                                                        {listaProductos.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.codigo}</td>
                                                                <td>{item.descripcion}</td>
                                                                <td><ObtenerNombreMedida codigo={item.unidad}/></td>
                                                                <td>{item.cantidad}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className='col-12 px-3 pb-3'>
                                            <div><span className='fw-bold'>Unidad de medida del peso bruto de la carga: </span><ObtenerNombreMedida codigo={unidadCarga}/></div>
                                            <div><span className='fw-bold'>Peso bruto de la carga: </span>{pesoBrutoCarga}</div>
                                            {cantBultos > 0 && (<div><span className='fw-bold'>Cantidad de bultos: </span>{cantBultos}</div>)}
                                        </div>
                                        <div className='col-12 px-3 py-2'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>DATOS DEL TRASLADO</div>
                                            <div><span className='fw-bold'>Fecha de entrega de bienes al transportista: </span>{formatoFecha(fechaEnvio)}</div>
                                        </div>
                                        <div className='col-12 px-3 py-2'>
                                            <div className='pb-2 fw-bold fs-5 text-secondary'>DATOS DE CONDUCTORES</div>
                                            <div>
                                                <span className='fw-bold'>PRINCIPAL: </span>
                                                <span className='fw-bold'>{nombreConductor} - </span>
                                                <span>DNI N° </span>
                                                <span className='fw-bold'>{docConductor} - </span>
                                                <span>Licencia N° </span>
                                                <span className='fw-bold'>{licenciaConductor}</span>
                                            </div>
                                            {
                                                docConductorS1 != "" && (
                                                    <div>
                                                        <span className='fw-bold'>SECUNDARIO: </span>
                                                        <span className='fw-bold'>{nombreConductorS1} - </span>
                                                        <span>DNI N° </span>
                                                        <span className='fw-bold'>{docConductorS1} - </span>
                                                        <span>Licencia N° </span>
                                                        <span className='fw-bold'>{licenciaConductorS1}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                docConductorS2 != "" && (
                                                    <div>
                                                        <span className='fw-bold'>SECUNDARIO: </span>
                                                        <span className='fw-bold'>{nombreConductorS2} - </span>
                                                        <span>DNI N° </span>
                                                        <span className='fw-bold'>{docConductorS2} - </span>
                                                        <span>Licencia N° </span>
                                                        <span className='fw-bold'>{licenciaConductorS2}</span>
                                                    </div>
                                                )
                                            }
                                            <div className='py-2 fw-bold fs-5 text-secondary'>DATOS DEL VEHÍCULO</div>
                                            <div>
                                                <span className='fw-bold'>PRINCIPAL: </span>
                                                <span>Placa N° </span>
                                                <span className='fw-bold'>{placaVehiculo} - </span>
                                                <span>Autorización especial N° </span>
                                                <span className='fw-bold'>{autorizacionVehiculo} </span>
                                                <span>emitida por </span>
                                                <span className='fw-bold'>{entidadVehiculo}</span>
                                            </div>
                                            {
                                                placaVehiculoS1 != "" && (
                                                    <div>
                                                        <span className='fw-bold'>SECUNDARIO: </span>
                                                        <span>Placa N° </span>
                                                        <span className='fw-bold'>{placaVehiculoS1} - </span>
                                                        <span>Autorización especial N° </span>
                                                        <span className='fw-bold'>{autorizacionVehiculoS1} </span>
                                                        <span>emitida por </span>
                                                        <span className='fw-bold'>{entidadVehiculoS1}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                placaVehiculoS2 != "" && (
                                                    <div>
                                                        <span className='fw-bold'>SECUNDARIO: </span>
                                                        <span>Placa N° </span>
                                                        <span className='fw-bold'>{placaVehiculoS2} - </span>
                                                        <span>Autorización especial N° </span>
                                                        <span className='fw-bold'>{autorizacionVehiculoS2} </span>
                                                        <span>emitida por </span>
                                                        <span className='fw-bold'>{entidadVehiculoS2}</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        {
                                            observaciones != "" && (
                                                <div className='col-12 p-3'>
                                                    <div className='pb-2 fw-bold fs-5 text-secondary'>OBSERVACIONES</div>
                                                    <div >{observaciones}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="py-3">
                                <label htmlFor="observaciones-guia" className="form-label fw-bold fs-4">Observaciones</label>
                                <textarea onChange={e=>HandlerObservaciones(e.target.value)} value={observaciones} className="form-control" id="observaciones-guia" rows="3"></textarea>
                            </div>
                            <div className='d-flex justify-content-center py-3'>
                                <button onClick={cargarConfirmacionEmision} disabled={indicadorGenerandoGuia} className='btn btn-lg btn-primary'>
                                    {indicadorGenerandoGuia && (<span className="spinner-border spinner-border-sm mx-2" aria-hidden="true"></span>)}
                                    <span role="status">Generar GRE {NMTipoGuiaRemision(tipoGuia)}</span>
                                </button>
                            </div>
                        </div>
                    </PasoGuia>
                </div>
            </div>
        </div>
    </div>
    </>)
    //#endregion
}

//================================================================================================================
//#region CONSTANTES
//================================================================================================================

const URL_DATOS_EMPRESA = process.env.REACT_APP_URL_DATOS_EMPRESA;
const URL_CONSULTA_TIPOS_DOCUMENTO = process.env.REACT_APP_URL_TIPOS_DOCUMENTO;
const URL_TIPOS_GUIA = process.env.REACT_APP_URL_TIPOS_GUIA;
const URL_MOTIVOS_TRASLADO = process.env.REACT_APP_URL_MOTIVOS_TRASLADO;
const URL_CONSULTA_PROVEEDOR = process.env.REACT_APP_URL_CONSULTA_PROVEEDOR;
const URL_CONSULTA_PRODUCTO = process.env.REACT_APP_URL_CONSULTA_PRODUCTO;
const URL_CONSULTA_TRANSPORTISTA = process.env.REACT_APP_URL_CONSULTA_TRANSPORTISTA;
const URL_SERIES = process.env.REACT_APP_URL_SERIES;
const URL_CONSULTA_CONDUCTOR = process.env.REACT_APP_URL_CONSULTA_CONDUCTOR;
const URL_CONSULTA_VEHICULO = process.env.REACT_APP_URL_CONSULTA_VEHICULO;
const URL_TIPOS_COMPROBANTE = process.env.REACT_APP_URL_TIPOS_COMPROBANTE;

const URL_REGISTRAR_GUIA = process.env.REACT_APP_URL_REGISTRAR_GUIA;

export const HEADERS_API = {
    'hToken': localStorage.getItem('r4'),
    'hCodigo': localStorage.getItem('r1')
}
//#endregion